import * as React from 'react'
import { Controller } from './Infraestructure/Controller'
import { ViewMain } from './Components/View'

const ManagerEntity = () => {
  const {
    init,
    trabajo,
    onSave,
    dataDocumentacionPEX,
    onSaveTabCalidad,
    asignaciones,
    valorizaciones,
    onSubmit,
    newFilesUpload,
    setNewFilesUpload,
    documentacionValorizacion,
    setDocumentacionValorizacion,
    dataDocumentacionBaremoPEX,
    onChange,
    dataMateriales,
    dataManoObraGlobal,
    dataPrecioEspecialidad,
    onSubmitFormAddMO,
    dataMaterialesAlmacen,
    cambiarEstadoAddresID
  } = Controller()

  React.useEffect(() => {
    init()
    return () => { }
    // eslint-disable-next-line
  }, [])

  return (
    <ViewMain
      trabajo={trabajo}
      onSave={onSave}
      dataDocumentacionPEX={dataDocumentacionPEX}
      onSaveTabCalidad={onSaveTabCalidad}
      asignaciones={asignaciones}
      valorizaciones={valorizaciones}
      onSubmit={onSubmit}
      documentacionValorizacion={documentacionValorizacion}
      newFilesUpload={newFilesUpload}
      setDocumentacionValorizacion={setDocumentacionValorizacion}
      setNewFilesUpload={setNewFilesUpload}
      dataDocumentacionBaremoPEX={dataDocumentacionBaremoPEX}
      onChange={onChange}
      dataMateriales={dataMateriales}
      dataManoObraGlobal={dataManoObraGlobal}
      dataPrecioEspecialidad={dataPrecioEspecialidad}
      onSubmitFormAddMO={onSubmitFormAddMO}
      dataMaterialesAlmacen={dataMaterialesAlmacen}
      cambiarEstadoAddresID={cambiarEstadoAddresID}
    />
  )
}

export default ManagerEntity